export class IDs {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ids",
            "baseName": "ids",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IDs.attributeTypeMap;
    }
    constructor() {
    }
}
